module.exports = __webpack_public_path__ + "media/base/unblock-92b19aad.svg";